import FeatureCategoryCallout from './component'
export default FeatureCategoryCallout
